import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function rebatesRCTIReducer(state = initialState.integrations, action) {
  switch (action.type) {
    case types.LIST_COMPANY_FILES_SUCCESS:
      return {
        ...state, companyFiles: action.items
      };
    case types.CLEAR_COMPANY_FILES_SUCCESS: 
        return {
            ...state, companyFiles: {}, total: 0
          };
    default:
      return state;
  }
}
